import { httpClient } from "@/http";
import { UserRead } from "../user";

export interface LoginRequest {
  username: string;
  password: string;
}

export interface LoginResponse {
  user: UserRead;
  token: string;
}

export const AuthService = {
  login(payload: LoginRequest) {
    return httpClient<HttpResponse<LoginResponse>>().post(
      "/api/v1/authenticate",
      payload
    );
  },
};
